import React from 'react';
import { useSetAtom } from 'jotai';
import { exploreViewAtom } from '../atoms';
import { Button, Tooltip } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import {
  APP_ERROR_MODAL_EXPLORE_DIMENSIONS,
  DPI_APP_CRASHES_V2_DIMENSIONS,
} from '@utils/dimension/appDimensionHelper';

function Header({ column, container }) {
  const setExploreView = useSetAtom(exploreViewAtom);
  const errorDimensions = APP_ERROR_MODAL_EXPLORE_DIMENSIONS.map((d) => d.dimension);
  const crashV2Dimensions = DPI_APP_CRASHES_V2_DIMENSIONS.map((d) => d.dimension);
  const allDimensions = [...errorDimensions, ...crashV2Dimensions];

  const handleClick = (columnKey) => {
    setExploreView({
      show: true,
      dimension: columnKey,
      isHighCardinality: false,
    });
  };

  return (
    <>
      {allDimensions.includes(column.key) && (
        <Tooltip placement="right" title="View errors">
          <Button
            style={{ fontSize: 18, lineHeight: 1, padding: 5 }}
            type="text"
            icon={<BugOutlined />}
            onClick={() => handleClick(column.key)}
          />
        </Tooltip>
      )}
    </>
  );
}

export default Header;
